<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>
        {{
          $t("PLACEHOLDERS.showAdditionalService", { name: data.name || "" })
        }}
      </h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #000">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Service Main Data ==== -->
      <form>
        <div class="row">
          <h6 class="col-12 mb-3">{{ $t("PLACEHOLDERS.providerInfo") }}</h6>

          <!-- Start:: Provider Name Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider.name"
            disabled
          />
          <!-- End:: Provider Name Input -->

          <!-- Start:: Provider Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.office_type')"
            v-model.trim="data.provider.exhibitor_type_trans"
            disabled
          />
          <!-- End:: Provider Type Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.provider.mobile"
            disabled
          />
          <!-- End:: Phone Input -->

          <h6 class="col-12 mb-3 mt-4">{{ $t("PLACEHOLDERS.serviceInfo") }}</h6>

          <!-- Start:: Service Name Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_ar')"
            v-model.trim="data.name_ar"
            disabled
          />
          <!-- End:: Service Name Arabic Input -->

          <!-- Start:: Service Name English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_en')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Service Name English Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model.trim="data.price_display"
            disabled
          />
          <!-- End:: Price Input -->

          <!-- Start:: Activation Status Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.activation_status')"
            v-model.trim="data.activation_status"
            disabled
          />
          <!-- End:: Activation Status Input -->

          <!-- Start:: Approval Date Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.approval_date')"
            v-model.trim="data.created_at_display"
            disabled
          />
          <!-- End:: Approval Date Input -->
        </div>
      </form>
      <!-- ==== End:: Service Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "SingleAdditionalService",
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        provider: {
          name: null,
          exhibitor_type_trans: null,
          mobile: null,
          exhibitor_name: null,
        },
        name_ar: null,
        name_en: null,
        name: null,
        price: null,
        price_display: null,
        currency: null,
        status: null,
        status_trans: null,
        is_active: null,
        activation_status: null,
        created_at: null,
        created_at_display: null,
        updated_at_display: null,
      },
      // End:: Data
    };
  },

  computed: {
    getAppLocale() {
      return this.$store.getters["AppLangModule/getAppLocale"];
    },
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `additional-services/${this.$route.params.id}`,
        });
        const serviceData = res.data.data.AdditionalService;

        this.data = {
          provider: {
            name: serviceData.provider?.name || this.$t("TABLES.noData"),
            exhibitor_type_trans:
              serviceData.provider?.exhibitor_type_trans ||
              this.$t("TABLES.noData"),
            mobile: serviceData.provider?.mobile || this.$t("TABLES.noData"),
            exhibitor_name:
              serviceData.provider?.exhibitor_name || this.$t("TABLES.noData"),
          },
          name_ar: serviceData.name_ar || this.$t("TABLES.noData"),
          name_en: serviceData.name_en || this.$t("TABLES.noData"),
          name: serviceData.name || this.$t("TABLES.noData"),
          price: serviceData.price,
          price_display: serviceData.price + " " + serviceData.currency,
          currency: serviceData.currency,
          status: serviceData.status,
          status_trans:
            serviceData.status_trans || this.getStatusText(serviceData.status),
          is_active: serviceData.is_active,
          activation_status: serviceData.is_active
            ? this.$t("PLACEHOLDERS.active")
            : this.$t("PLACEHOLDERS.inactive"),
          created_at: serviceData.created_at,
          created_at_display: this.formatDate(serviceData.created_at),
          updated_at_display: this.formatDate(serviceData.updated_at),
        };
      } catch (error) {
        console.log(error.response.data.message);
        this.$message.error(error.response.data.message);
      }
    },

    // Status helpers
    getStatusColor(status) {
      switch (status) {
        case "pending":
          return "orange";
        case "approved":
          return "green";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },

    getStatusText(status) {
      switch (status) {
        case "pending":
          return this.$t("PLACEHOLDERS.pending");
        case "approved":
          return this.$t("PLACEHOLDERS.approved");
        case "rejected":
          return this.$t("PLACEHOLDERS.rejected");
        default:
          return this.$t("PLACEHOLDERS.unknown");
      }
    },

    formatDate(dateString) {
      if (!dateString) return this.$t("TABLES.noData");
      const date = new Date(dateString);
      return date.toLocaleDateString(
        this.getAppLocale === "ar" ? "ar-EG" : "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      );
    },
  },

  created() {
    this.getDataToShow();
  },
};
</script>

<style scoped>
.single_step_form_content_wrapper {
  padding: 20px;
}

.badges_wrapper {
  margin-bottom: 20px;
}

.status-badge {
  padding: 8px 16px;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  text-align: center;
}

.status-approved {
  background-color: #28a745;
}

.status-pending {
  background-color: #ffc107;
  color: #212529;
}

.status-rejected {
  background-color: #dc3545;
}
</style>
